import type { PlateListing, PlatePosition } from "../../../api/catalogue";

/** One listing at one position: a line of the parts list. */
export interface PlateRow {
  key: string;
  position: PlatePosition;
  listing: PlateListing;
  /** The first listing at its position carries the position's chip and note. */
  first: boolean;
  /** How many listings share the position, like five crankshafts at position 10. */
  groupSize: number;
}

export const rowKey = (position: PlatePosition, listing: PlateListing) => `${position.id}-${listing.id}`;

/** The parts list in the book's order, split into numbered rows and those the book lists without a number. */
export function plateRows(positions: PlatePosition[]): { numbered: PlateRow[]; unnumbered: PlateRow[] } {
  const rows = positions.flatMap((position) =>
    position.listings.map((listing, index) => ({
      key: rowKey(position, listing),
      position,
      listing,
      first: index === 0,
      groupSize: position.listings.length,
    })),
  );
  return { numbered: rows.filter((row) => row.position.position_number !== null), unnumbered: rows.filter((row) => row.position.position_number === null) };
}

/** Finds a position by the number a customer types, ignoring spaces and case: "39-1", " 10 ". */
export function findPosition(positions: PlatePosition[], typed: string): PlatePosition | undefined {
  const wanted = typed.trim().toLowerCase();
  return wanted ? positions.find((position) => position.position_number?.toLowerCase() === wanted) : undefined;
}
